import React from "react";
import { ShoppingBag, MapPin } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { motion } from "framer-motion";

const Header = () => {
  const { count, setOpen } = useCart();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className="fixed top-0 left-0 right-0 z-40 backdrop-blur-xl"
      style={{ background: "rgba(15,13,12,0.7)", borderBottom: "1px solid var(--awd-border)" }}
      data-testid="site-header"
    >
      <div className="kente-stripe" />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-4 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="logo-link">
          <img
            src="https://customer-assets.emergentagent.com/job_eats-hub-1/artifacts/6ho2af36_Untitled_design.zip_-_2.png"
            alt="Afro World Delight"
            className="h-10 w-10 object-contain"
          />
          <div className="leading-tight">
            <div className="font-display text-lg tracking-tight">Afro World Delight</div>
            <div className="label-mini hidden sm:block">West African · Omaha, NE</div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          <button onClick={() => scrollTo("menu")} className="link-reveal text-sm tracking-wider" data-testid="nav-menu">MENU</button>
          <button onClick={() => scrollTo("how")} className="link-reveal text-sm tracking-wider" data-testid="nav-how">HOW TO ORDER</button>
          <button onClick={() => scrollTo("story")} className="link-reveal text-sm tracking-wider" data-testid="nav-story">STORY</button>
          <button onClick={() => scrollTo("contact")} className="link-reveal text-sm tracking-wider" data-testid="nav-contact">CONTACT</button>
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden md:flex items-center gap-2 text-xs tracking-widest uppercase" style={{ color: "var(--awd-text-2)" }}>
            <span className="pulse-dot inline-block w-2 h-2 rounded-full" style={{ background: "var(--awd-ochre)" }} />
            Pre-Order Open
          </div>
          <button
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 px-4 py-2.5 border text-sm tracking-wider uppercase"
            style={{ borderColor: "var(--awd-border-2)" }}
            data-testid="cart-toggle-button"
          >
            <ShoppingBag size={16} />
            <span className="hidden sm:inline">Cart</span>
            <span
              className="ml-1 inline-flex items-center justify-center min-w-[22px] h-[22px] text-[10px] font-bold"
              style={{ background: count > 0 ? "var(--awd-terracotta)" : "var(--awd-border)", color: "var(--awd-text)" }}
              data-testid="cart-count"
            >{count}</span>
          </button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
